import { render, staticRenderFns } from "./GenericInfoDrawer.vue?vue&type=template&id=3e90f4f5&scoped=true&"
import script from "./GenericInfoDrawer.vue?vue&type=script&lang=js&"
export * from "./GenericInfoDrawer.vue?vue&type=script&lang=js&"
import style0 from "./GenericInfoDrawer.vue?vue&type=style&index=0&id=3e90f4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e90f4f5",
  null
  
)

export default component.exports